// @core/api/endpoints/attachment/initiate_multipart_upload.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InitiateMultipartUploadRequest,
  InitiateMultipartUploadResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Initiate multipart upload for large files
 * Starts a multipart upload session for large files. Returns presigned URLs for each part. Parts can be uploaded in parallel for improved performance.
 */
export async function InitiateMultipartUpload(
  data: InitiateMultipartUploadRequest,
  options?: RequestOptions
): Promise<InitiateMultipartUploadResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments/multipart/initiate`;
  const requestOptions = options;
  return client.post<InitiateMultipartUploadResponse>(requestPath, data, requestOptions);
}
